import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchGet } from '../../fetch/fetchConfig'
import { QUERY_DELETE_TEMPLATE, QUERY_GET_EMAIL_RECIPIENTS, QUERY_GET_TEMPLATE_TYPES, QUERY_GET_TEMPLATES, QUERY_GET_TEMPLATES_PAG, QUERY_POST_CREATE_TEMPLATE, QUERY_PUT_UPDATE_TEMPLATE} from '../../fetch/constantQueries'
import { openModal } from '../modal/modalSlice';
import { baseThunk, getUrl } from '../../fetch/basicThunk';

export const getTemplates = createAsyncThunk(
  'templates/getTemplates',
  async (filters, thunkApi) => {
        const response = await fetch( getUrl() + QUERY_GET_TEMPLATES , fetchGet());
        if (!response.ok) {
            if(response.status === 401){thunkApi.dispatch(openModal({ type: "error", message:"Error de autenticación. Introduzca de nuevo sus credenciales." }))}
            else{thunkApi.dispatch(openModal({ type: "error" }))}
            throw response.status
      };
        const data = response.json()
        return data
    }
)

export const getTemplatesPag = baseThunk("templates/getTemplatesPag", QUERY_GET_TEMPLATES_PAG, "GET");
export const getTemplateTypes = baseThunk("templates/getTemplateTypes", QUERY_GET_TEMPLATE_TYPES, "GET");
export const getEmailRecipients =baseThunk("templates/getEmailRecipients", QUERY_GET_EMAIL_RECIPIENTS, "GET")
export const createTemplate = baseThunk("templates/createTemplate", QUERY_POST_CREATE_TEMPLATE, "POST")
export const editTemplate = baseThunk("templates/editTemplate", QUERY_PUT_UPDATE_TEMPLATE, "PUT")
export const deleteTemplate = baseThunk("templates/deleteTemplate", QUERY_DELETE_TEMPLATE, "DELETE")